import { CalendarEventEntity } from '../store/schema/CalendarEventEntity';
import { EventsCacheLockId, getEventsWithKeysFromLock } from 'owa-events-cache';
import { getStore } from '../store/store';

export function filterCalendarEvents(
    folderId: string,
    predicate: (event: CalendarEventEntity) => boolean
) {
    const store = getStore();
    const cache = store.calendarFolderEvents.get(folderId);

    if (cache) {
        return cache.events.filter(predicate);
    } else {
        return [];
    }
}

export function getCalendarEventWithId(
    eventId: string,
    folderId: string | null = null
): CalendarEventEntity | null {
    if (folderId) {
        const [event] = filterCalendarEvents(folderId, event => event.ItemId.Id === eventId);
        return event || null;
    } else {
        return filterCalendarEventAcrossAllFolders(e => e.ItemId.Id === eventId);
    }
}

export function getCalendarEventWithKey(
    key: string,
    folderId: string = null
): CalendarEventEntity | null {
    if (folderId) {
        const [event] = filterCalendarEvents(folderId, event => event.Key === key);
        return event || null;
    } else {
        return filterCalendarEventAcrossAllFolders(event => event.Key === key);
    }
}

export function getCalendarEventWithKeyFromLock(
    folderId: string | null,
    key: string,
    lockId: EventsCacheLockId
): CalendarEventEntity | null {
    if (folderId) {
        return getCalendarEventWithKeyForFolderFromLock(folderId, key, lockId);
    } else {
        return getCalendarEventWithKeyForAnyFolderFromLock(key, lockId);
    }
}

function getCalendarEventWithKeyForFolderFromLock(
    folderId: string,
    key: string,
    lockId: EventsCacheLockId
): CalendarEventEntity | null {
    const store = getStore();
    const cache = store.calendarFolderEvents.get(folderId);

    if (cache) {
        const [event] = getEventsWithKeysFromLock([key], lockId, cache);
        return event || null;
    } else {
        return null;
    }
}

function getCalendarEventWithKeyForAnyFolderFromLock(
    key: string,
    lockId: EventsCacheLockId
): CalendarEventEntity | null {
    const store = getStore();

    const folderIds = [...store.calendarFolderEvents.keys()];

    for (let i = 0; i < folderIds.length; i++) {
        const folderId = folderIds[i];
        const cache = store.calendarFolderEvents.get(folderId);
        const [event] = cache ? getEventsWithKeysFromLock([key], lockId, cache) : [null];

        if (event) {
            return event;
        }
    }

    return null;
}

function filterCalendarEventAcrossAllFolders(
    predicate: (event: CalendarEventEntity) => boolean
): CalendarEventEntity | null {
    const store = getStore();

    const folderIds = [...store.calendarFolderEvents.keys()];

    for (let i = 0; i < folderIds.length; i++) {
        const folderId = folderIds[i];
        const cache = store.calendarFolderEvents.get(folderId);
        const [event] = cache ? cache.events.filter(predicate) : [null];

        if (event) {
            return event;
        }
    }

    return null;
}
